import request from '../utils/request';

export function listRecommendProductsInfo() {
  return request.get('/api/product/recommend');
}

export function listRecommendAcyivityInfo() {
  return request.get('/api/news_activities/recommend');
}

export interface INewsProps {
  limit: number;
  page: number;
  type?: 1 | 2 | 3;
}

export function listRecommentNews(params: INewsProps) {
  return request.get('/api/news_activities/get_newsActivities', {
    params,
  });
}

export function listHomepageType() {
  return request.get('/api/catalog/get_catalogs', {
    params: {
      level: 1,
    },
  });
}
